//import $ from "jquery";
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';
import MobileDetect from "./mobile";

class VideoInit {

    Init = () => {

        //videojs(document.querySelector('.video-js'));
        function scrollbarWidth() {
            let documentWidth = parseInt(document.documentElement.clientWidth);
            let windowsWidth = parseInt(window.innerWidth);
            let scrollbarWidth = windowsWidth - documentWidth;
            return scrollbarWidth;
        }

        $(document).keyup(function(e) {
            if ((e.key === "Escape" || e.key === "Esc" || e.key === "27") && $('.main--video .vjs-close').length) {
                $('.vjs-close').click();
            }
        });

        $('.watch-link').bind("click", function(e){
            e.preventDefault();

            let body = $('body');
            body.css('margin-right',scrollbarWidth()+'px');
            body.css('overflow','hidden');
            $('.main--video').addClass('open visible');
            if(!$('.main--video .vjs-close').length){
                let need_but = $('.main--video .vjs-control-bar .vjs-fullscreen-control');
                need_but.remove();
                $('.main--video .vjs-control-bar').append('<button class="vjs-fullscreen-control vjs-close vjs-control vjs-button" type="button" title="Close"></button>');
                let need_but_full = $('.main--video .vjs-control-bar .vjs-fullscreen-control.vjs-close');
                need_but_full.html(need_but.html());

                $('.vjs-close').bind("click", function(e){
                    e.preventDefault();
                    e.stopPropagation();
                    let body = $('body');
                    if(!body.hasClass('ready')){
                        body.addClass('ready');
                    }
                    let video = $(".main--video video").get(0);
                    video.load();

                    //if (video.) {
                       // $('.main--video .vjs-play-control').click();
                        //$('.main--video video').stop();
                    //}
                    $('.main--video').removeClass('open');
                    setTimeout(function () {
                        body.css('overflow','');
                        body.css('margin-right','');
                        $('.main--video').removeClass('visible');
                    },500);
                    return false;
                });
            }

            let video = $(".main--video video").get(0);
            video.load();
            setTimeout(function() {
                if (!video.playing) {
                    video.play();
                }
            }, 0);
        });

        /*
        //let vid_timer = '';
        if($('.main--video').length){
            //if(!MobileDetect.Init() && $('.main--video').length){

            $('.logo').hide();

            let text_but = 'skip video';
            if($('body').hasClass('lang-ru')){
                text_but = 'Пропустить видео';
            }
            $('.main--video').append('<a href="#" class="button main--video__but"><span>'+text_but+'</span></a>');
            let video = videojs('example_video_1').ready(function(){
                let player = this;
                $('.watch-link').click();
                $('.logo').show();
                player.on('ended', function() {
                    $('.vjs-close').click();
                });
                $('.main--video__but').bind("click", function(e){
                    e.preventDefault();
                    $('.vjs-close').click();
                });
            });
        };
 */

        /*
vid_timer = setInterval(function() {
    if($('.vjs-user-active').length){
        $('.watch-link').click();
        clearInterval(vid_timer);
        $('.logo').show();
        //$('body').addClass('ready');
    }
}, 10);
 */

        //videojs.load().then(videojs => {
        //    videojs(document.querySelector('.video-js'));
        //}).catch(error => console.log('Failed to load Video Player', error));


    };
    
}


export default new VideoInit;